import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/auth';

export default function Home() {
  const { user } = useAuthStore();

  const categories = [
    { id: 'listings', icon: '🛍', label: 'Товары', path: '/listings', color: 'bg-blue-100' },
    { id: 'services', icon: '💼', label: 'Услуги', path: '/services', color: 'bg-green-100' },
    { id: 'barters', icon: '🔁', label: 'Бартер', path: '/barters', color: 'bg-yellow-100' },
    { id: 'auctions', icon: '🕑', label: 'Аукционы', path: '/auctions', color: 'bg-purple-100' }
  ];

  const quickActions = [
    { icon: '➕', label: 'Создать объявление', path: '/listings/create' },
    { icon: '💳', label: 'Подписка', path: '/subscription' },
    { icon: '⚙️', label: 'Настройки', path: '/settings' }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Привет, {user?.firstName}! 👋</h1>
          <p className="text-tg-theme-hint">Добро пожаловать в Биржу</p>
        </div>
        {user?.isPremium && (
          <span className="bg-yellow-400 text-yellow-900 px-2 py-1 rounded-full text-xs font-medium">
            ⭐️ Premium
          </span>
        )}
      </div>

      {/* User Stats */}
      <div className="card">
        <div className="flex items-center justify-around">
          <div className="text-center">
            <p className="text-2xl font-bold">⭐️ {user?.rating.toFixed(1) || '0.0'}</p>
            <p className="text-xs text-tg-theme-hint">Рейтинг</p>
          </div>
          <div className="h-8 w-px bg-tg-theme-hint/20" />
          <div className="text-center">
            <p className="text-2xl font-bold">{user?.dealsCount || 0}</p>
            <p className="text-xs text-tg-theme-hint">Сделок</p>
          </div>
          <div className="h-8 w-px bg-tg-theme-hint/20" />
          <div className="text-center">
            <p className="text-2xl font-bold">{user?.reviewsCount || 0}</p>
            <p className="text-xs text-tg-theme-hint">Отзывов</p>
          </div>
        </div>
      </div>

      {/* Categories */}
      <div>
        <h2 className="text-lg font-semibold mb-3">Разделы</h2>
        <div className="grid grid-cols-2 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={cat.path}
              className={`${cat.color} rounded-xl p-4 flex flex-col items-center justify-center hover:opacity-90 transition-opacity`}
            >
              <span className="text-3xl mb-2">{cat.icon}</span>
              <span className="font-medium text-sm text-gray-800">{cat.label}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div>
        <h2 className="text-lg font-semibold mb-3">Быстрые действия</h2>
        <div className="space-y-2">
          {quickActions.map((action, index) => (
            <Link
              key={index}
              to={action.path}
              className="card flex items-center justify-between hover:opacity-90"
            >
              <div className="flex items-center gap-3">
                <span className="text-xl">{action.icon}</span>
                <span>{action.label}</span>
              </div>
              <span className="text-tg-theme-hint">→</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Premium Banner */}
      {!user?.isPremium && (
        <Link to="/subscription" className="block">
          <div className="bg-gradient-to-r from-yellow-400 to-orange-500 rounded-xl p-4 text-white">
            <div className="flex items-center gap-3">
              <span className="text-3xl">💎</span>
              <div>
                <h3 className="font-bold">Получите Premium</h3>
                <p className="text-sm opacity-90">Неограниченные объявления и продвижение</p>
              </div>
            </div>
          </div>
        </Link>
      )}

      {/* Info */}
      <div className="text-center text-xs text-tg-theme-hint">
        <p>🇷🇺 Россия • 🇰🇿 Казахстан • 🇧🇾 Беларусь</p>
        <p className="mt-1">Версия 1.0.0</p>
      </div>
    </div>
  );
}
